import { render, staticRenderFns } from "./PriceInProgress.vue?vue&type=template&id=05ecb5c9&"
import script from "./PriceInProgress.vue?vue&type=script&lang=js&"
export * from "./PriceInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports